<div class="card-slimmable" [ngClass]="slimMode ? 'slim' : 'wide'" (click)="onSelect($event)">
  <div class="card-body">
    <div class="content-left" *transloco="let t">
      <div class="card-status-icon" [ngClass]="iconBackgroundClass" [style]="'--status-background-color: var(--'+getBackgroundColour(progressPercent)+');'">
        @if (icon) {
          <div class="progress-bar-circle" [style]="'--progress-bar-circle-value: '+progressPercent+'%'">
            @if (icon.identifier_1) {
              <i [ngClass]="icon.identifier_1"></i>
            }
            @if (!icon.identifier_1 && icon.identifier_2) {
              <img [src]="cloudinary_base_url+'w_32,c_fill,ar_1:1,r_max/'+icon.identifier_2+'.svg'">
            }
          </div>
        }
      </div>
      <div class="card-text text-wrap">
        <!-- <p class="card-title">{{ translationKey ? t(translationKey) : text }}</p> -->
        <!-- <div class="little-red-box">???</div> -->
        <p class="card-title">{{ text }}</p>
        <p class="card-value">{{ round(progressPercent) }}%</p>
      </div>
    </div>
    <div class="content-right">
      <button class="btn" aria-label="Go to subject of this progress indicator" (click)="onSelect($event)">
        <i class="fa-solid fa-angle-left"></i>
      </button>
    </div>
  </div>
</div>